// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6ab2e403","667":"1fc2669c","977":"23c97f2b"}[chunkId] + ".chunk.js";
};